import { Button, DialogActions } from "@mui/material"

// others
import { FeeTypeModalProps } from "../../../interfaceTypes/props"
import { FormProvider, useForm } from "react-hook-form"
import { useCreateFeeTypeMutation, useUpdateFeeTypeMutation } from "../../../../generated"

// components
import { Alert } from "../../common/Alert"
import { CustomController } from "../../common/CustomController"
import { CustomModal } from "../../common/CustomModal"
import { yupResolver } from "@hookform/resolvers/yup"
import { addFeeTypeValidationSchema } from "../../../validationSchema"

const FeeTypeModal = ({ isOpen, fee, handleClose, refetch }: FeeTypeModalProps ) => {
  const methods = useForm<{feeType: string}>({
    resolver: yupResolver(addFeeTypeValidationSchema),
    mode: 'onChange',
    defaultValues: {
      feeType: fee?.feeType || '',
    }
  })

  const { handleSubmit, reset } = methods

  const [ createFeeType ] = useCreateFeeTypeMutation({
      onError: error => {
        Alert.error(error.message)
      },
      onCompleted: data => {
        reset()
        refetch?.()
        handleClose?.()
        if (data) Alert.success('Fee Type created successfully!')
      }
  })
  
  const [ updateFeeType ] = useUpdateFeeTypeMutation({
      onError: error => {
        Alert.error(error.message)
      },
      onCompleted: data => {
        reset()
        refetch?.()
        handleClose?.()
        if (data) Alert.success('Fee Type updated!')
      }
  })

  const onSubmit = async (data: {feeType: string}) => {
    console.log('fee', data)
    const { feeType } = data
    
    fee?.id ? 
      await updateFeeType({ 
        variables: { 
          updateFeeTypeId: fee.id,
          feeType
        
        } 
      }) :
      await createFeeType({
        variables: {
          feeType 
        }
      })
  }

  const closeModal = () => {
    reset()
    handleClose?.()
  }

  return (
    <CustomModal isOpen={isOpen ?? false} title={fee?.id ? 'Edit Fee Type' : 'Add Fee Type'} handleClose={closeModal} >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} style={{ display: 'grid', gap: 12}}>    
          <CustomController controllerLabel="Fee Type" controllerName="feeType" fieldType="text" defaultValue="256"/>
        
          <DialogActions>
            <Button variant="text" onClick={handleClose} sx={{ color: 'gray' }}>
              Cancel
            </Button>
          
            <Button type="submit" variant="contained" >
              {fee?.id ? 'Save' : 'Add'}
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </CustomModal>
  )
}

export default FeeTypeModal